import * as angular from "angular";

angular
  .module('bringoz.admin.planning')
  .constant('Drafts_PN', {
    database: 'drafts',
    isBranchEntity: false
  });
